import { TwSession, type TwRestSession } from "@tastyworks/tastyworks-api"

const TW_SESSION_ID_KEY = "tw-session-id"
const TW_EMAIL_KEY = "tw-email"
const TW_USERNAME_KEY = "tw-username"

class Session extends TwSession implements TwRestSession {
  constructor() {
    super("AO2")
  }

  get currentEmail() {
    return sessionStorage.getItem(TW_EMAIL_KEY) as string
  }

  set currentEmail(email) {
    sessionStorage.setItem(TW_EMAIL_KEY, email)
  }

  get currentUsername() {
    return sessionStorage.getItem(TW_USERNAME_KEY) as string
  }

  set currentUsername(username) {
    sessionStorage.setItem(TW_USERNAME_KEY, username)
  }

  get sessionToken() {
    return sessionStorage.getItem(TW_SESSION_ID_KEY) ?? ""
  }

  set sessionToken(token) {
    sessionStorage.setItem(TW_SESSION_ID_KEY, token)
  }

  clear() {
    sessionStorage.removeItem(TW_SESSION_ID_KEY)
    sessionStorage.removeItem(TW_EMAIL_KEY)
    sessionStorage.removeItem(TW_USERNAME_KEY)
  }
}

const session = new Session()

export default session
